module.exports = __webpack_public_path__ + "images/72250432baa9335a89775e338657db3e-IMG_8824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_8824.jpg
// module id = ./src/assets/images/slides/living/IMG_8824.jpg
// module chunks = 0